'use client'

import useDetectScroll, { Direction } from '@smakss/react-scroll-direction'
import { CaseStudy } from 'enums/CaseStudy.enum'
import { useDeviceType } from 'hooks/useDeviceType'
import { useInView } from 'motion/react'
import Image from 'next/image'
import { useEffect, useRef } from 'react'
import styles from './Carousel.module.scss'

export interface CarouselImage {
  src: string
  width: number
  height: number
  alt: string
}

type CarouselProps = {
  images: CarouselImage[]
  caseStudy: CaseStudy
}

const Carousel = ({ images, caseStudy }: CarouselProps) => {
  const targetRef = useRef<HTMLElement>(null)
  const inView = useInView(targetRef, { amount: 0.5 })
  const { scrollDir, scrollPosition } = useDetectScroll()
  const { isMobile, isTablet } = useDeviceType()

  useEffect(() => {
    function handleScroll() {
      const element = targetRef.current
      if (element) {
        if (inView) {
          if (scrollDir === Direction.Down) {
            element.scrollLeft += element.scrollWidth * 0.007
          } else if (scrollDir === Direction.Up) {
            element.scrollLeft -= element.scrollWidth * 0.007
          }
        }
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [inView, scrollDir, scrollPosition.top])

  return (
    <>
      {isMobile || isTablet ? (
        <section className={styles['image-container']}>
          <div className={styles[caseStudy]}></div>
        </section>
      ) : (
        <section className={styles.carousel} ref={targetRef}>
          {images.map((img) => (
            <Image key={img.alt} src={img.src} width={img.width} height={img.height} alt={img.alt} />
          ))}
        </section>
      )}
    </>
  )
}

export default Carousel
